module.exports = __webpack_public_path__ + "static/img/wx-service.6b89ff57.jpg";